import React from 'react'
import { Stack, Center, Text, Button, Grid, Group, Image, Anchor, Box } from '@mantine/core'
import errorImg from '@/assets/img/error.png'
import { ReactComponent as IcRefresh } from '@/assets/icon/ic_refresh.svg'
import etfStyles from '@/components/etfs/ETFResultHeader.module.css'

const Error500 = () => {
  const handleReload = () => {
    window.location.reload()
  }

  return (
    <Center>
      <Grid align="center" gutter="md" maw={800} mt="md">
        <Grid.Col span={{ base: 12, md: 8 }}>
          <Stack>
            <Box className={etfStyles.textWithStyleUnderScore}>
              <Text size="3xl" fw={700} lh={'56px'}>
                <Text span c="blue.3" inherit>
                  Oops!
                </Text>{' '}
                Something went wrong on our end.
              </Text>
            </Box>

            <Text c="grey.7" size="mdlg" mb="md">
              {"We're experiencing a technical issue. Our team has been notified and is working to fix it."}
            </Text>

            <Group gap="sm">
              <Button onClick={handleReload}>
                <Group gap="3xs">
                  <IcRefresh />
                  Reload the page
                </Group>
              </Button>
              <Text c="grey.7">
                or visit our{' '}
                <Anchor href="/assistance/contact" c="grey.8" fw={600} td="underline">
                  Help center
                </Anchor>
              </Text>
            </Group>
          </Stack>
        </Grid.Col>
        <Grid.Col span={4} display={{ base: 'none', md: 'block' }}>
          <Image src={errorImg} alt="Error illustration" width={200} height="auto" />
        </Grid.Col>
      </Grid>
    </Center>
  )
}

export default Error500
